import { useState } from 'react';
import type { IGmailPageLoadingStates } from '@/@types/gmail';

/**
 * Extracts the three loading-state booleans from GmailPage into a custom hook,
 * satisfying the project rule that 3+ useState calls must live in a dedicated hook.
 */
export function useGmailPageLoadingStates(): IGmailPageLoadingStates {
  const [isSyncing, setIsSyncing] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isMarkingReadStatus, setIsMarkingReadStatus] = useState(false);

  return {
    isSyncing,
    setIsSyncing,
    isDeleting,
    setIsDeleting,
    isMarkingReadStatus,
    setIsMarkingReadStatus,
  };
}
